import { inject, Service } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { lastValueFrom, Observable } from 'rxjs';

import { BaasToepassingService } from '@lvflanders/bar';

import { HoedanigheidpickerDto } from '../../api/models';
import { VoorwiepickerApiService } from '../../api/services';
import { StartschermHoedanigheidDialog } from '../../components/startscherm-hoedanigheid-dialog/startscherm-hoedanigheid-dialog';
import { StartschermVoorwieDialog } from '../../components/startscherm-voorwie-widget/startscherm-voorwie-dialog/startscherm-voorwie-dialog';
import { HoedanigheidpickerDialogData } from '../../models/v2/hoedanigheidpicker-dialog-data.type';
import { HoedanigheidpickerApiService } from './../../api/services/hoedanigheidpicker-api.service';

@Service({ autoProvided: false })
export class StartschermV2KlantService {
    readonly #dialog = inject(MatDialog);
    readonly #hoedanigheidpickerApiService = inject(HoedanigheidpickerApiService);
    readonly #voorwiepickerApiService = inject(VoorwiepickerApiService);
    readonly #toepassing = inject(BaasToepassingService);

    /** Sets or picks the hoedanigheid. */
    async setOrPickHoedanigheid(actie: string = null): Promise<HoedanigheidpickerDto> {
        const data = await lastValueFrom(this.#hoedanigheidpickerApiService.getHoedanighedenForPickerByAction({ actie: actie }));
        // we automatically choose an hoedanigheid (or intern)
        if (data && data.length == 1) {
            await this.#toepassing.setHoedanigheid(data[0].hoedanigheid, data[0].hoedanigheidRolcode);
            return data[0];
        } else {
            // there are more than 1 hoedanigheden, e must ask the user manually
            // open up the hoedanigheid dialog and pass the choosable hoedanigheden

            return await lastValueFrom(this.#openHoedanigheidDialog(data, true));
        }
    }

    openVoorwieDialog(noNavigation, disableClose = false, doReset = true): Promise<any> {
        const dialogRef = this.#dialog.open(StartschermVoorwieDialog, {
            minWidth: '70vw',
            disableClose: disableClose,
            data: { noNavigation, doReset }
        });
        return lastValueFrom(dialogRef.afterClosed());
    }

    async openVoorwieDialogWithAction(action: string, disableClose = false): Promise<any> {
        const clients = await this.#getVoorwiesFilteredByAction(action);
        const dialogRef = this.#dialog.open(StartschermVoorwieDialog, {
            minWidth: '70vw',
            disableClose: disableClose,
            data: { noNavigation: true, doReset: false, clients: clients }
        });
        return lastValueFrom(dialogRef.afterClosed());
    }

    /**
     * Opens the hoedanigheid dialog if there are more than 1 hoedanigheden to choose from.
     * @param hoedanigheden Array of hoedanigheden to choose from.
     */
    #openHoedanigheidDialog(hoedanighedenToShow: HoedanigheidpickerDto[], noNavigation: boolean): Observable<HoedanigheidpickerDto> {
        const dialogRef = this.#dialog.open(StartschermHoedanigheidDialog, {
            data: { clients: hoedanighedenToShow, noNavigation: noNavigation } as HoedanigheidpickerDialogData,
            minWidth: '70vw'
        });

        return dialogRef.afterClosed();
    }

    async #getVoorwiesFilteredByAction(action: string) {
        const voorwies = await lastValueFrom(this.#voorwiepickerApiService.getVoorwiesFilteredByAction({ actie: action }));
        return voorwies;
    }
}
